import moment from 'moment';
import tz_lookup from 'tz-lookup';

export const utc = (lat: number, lon: number) => {
  if (lat && lon) {
    const utc = moment.utc().tz(tz_lookup(lat, lon)).utcOffset() / 60;
    return utc > 0 ? `+${utc}` : `${utc}`;
  }
};

export const timeByZone = (lat: number, lon: number, unix: number, timeFormat: string) => {
  return moment.unix(unix).locale('en').tz(tz_lookup(lat, lon)).format(timeFormat);
};
